import React from 'react';

const phoneNumbers = {};

export default function (props) {
  return (
    <div className="dynamic-result-page--list">
      {props.vendorList.map((vendor) => {
        return VendorWithInformation(vendor.name);
      })}
    </div>
  );
}

const VendorWithInformation = (vendor) => {
  return (
    <div className="dynamic-result-page--list-item">
      <div className="dynamic-result-page--list-item--icon" style={{ padding: '10px 10px 10px 20px' }}>
        <i className="fa fa-check-circle" style={{ fontSize: '30px' }}></i>
      </div>
      <div className="dynamic-result-page--list-item--text" style={{ padding: '20px' }}>
        <p
          style={{
            padding: '0 0 0 0',
            fontFamily: 'Helvetica,Arial,sans-serif',
            fontWeight: '600',
            color: '#000',
            lineHeight: 1.5,
            fontSize: '16px',
            margin: '1px 0 0 0',
          }}
        >
          {vendor}
        </p>
        {vendor in phoneNumbers && (
          <>
            <p style={{ marginTop: '4px' }}>Infórmate Gratis:</p>
            <p>
              <a
                href={`tel:${phoneNumbers[vendor]}`}
                style={{ display: 'inline-block', fontSize: '15px', marginTop: '0px', fontWeight: 600 }}
              >
                {phoneNumbers[vendor]}
              </a>
            </p>
          </>
        )}
      </div>
    </div>
  );
};
